import { jsxs as e, jsx as c } from "react/jsx-runtime";
function x(r) {
  return /* @__PURE__ */ e(
    "svg",
    {
      fill: "rgb(var(--text-secondary))",
      width: "15",
      height: "25",
      viewBox: "0 0 15 25",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ c("circle", { cx: "2.5", cy: "2.4942", r: "2.5" }),
        /* @__PURE__ */ c("circle", { cx: "2.5", cy: "12.4942", r: "2.5" }),
        /* @__PURE__ */ c("circle", { cx: "2.5", cy: "22.4942", r: "2.5" }),
        /* @__PURE__ */ c("circle", { cx: "12.5", cy: "2.4942", r: "2.5" }),
        /* @__PURE__ */ c("circle", { cx: "12.5", cy: "12.4942", r: "2.5" }),
        /* @__PURE__ */ c("circle", { cx: "12.5", cy: "22.4942", r: "2.5" })
      ]
    }
  );
}
export {
  x as DragIcon
};
